import testYourTag from '../steps/media/testYourTag.png';
import createConversionGoalorAudience from '../steps/media/createConversionGoalorAudience.png';
import uetTagInsights from '../steps/media/uetTagInsights.png';

export const getwebInsightsGraphStyle = () => ({
  webInsightsInstructionGraph: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: 20,
    paddingLeft: '30px',
    paddingTop: '10px',

    '& .webInsights-graph-container': {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridGap: 20,

      '& .webInsights-graph-item': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        backgroundColor: '#F8F8F8',
        padding: '20px',
      },
    },
    '& .webInsights-graph-step-1': {
      height: 130,
      width: 270,
      backgroundImage: `url("${testYourTag}")`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
    '& .webInsights-graph-step-2': {
      height: 130,
      width: 270,
      backgroundImage: `url("${createConversionGoalorAudience}")`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
    '& .webInsights-graph-step-3': {
      height: 130,
      width: 270,
      backgroundImage: `url("${uetTagInsights}")`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
  },
});
